/**
 * Factory para gerar stubs de canais "Em breve".
 * Usado pelos plugins Instagram/Messenger/SiteWidget enquanto não são funcionais.
 */

import React from 'react';
import { CHANNEL_CATEGORIES } from '../types';

export function createStubChannel({
  id,
  name,
  description,
  icon,
  color,
  gradient,
  category = CHANNEL_CATEGORIES.MESSAGING,
}) {
  const Icon = icon;

  return {
    id,
    name,
    description,
    icon,
    color,
    gradient,
    category,
    isAvailable: false,

    renderCard: () => (
      <div className="channel-card channel-card--coming-soon">
        <span className="channel-card__badge channel-card__badge--coming-soon">
          Em breve
        </span>
        <div
          className="channel-card__icon"
          style={{ background: gradient, color: '#fff' }}
        >
          <Icon size={22} />
        </div>
        <div className="channel-card__body">
          <h5 className="channel-card__name">{name}</h5>
          <p className="channel-card__description">{description}</p>
        </div>
      </div>
    ),
  };
}
